import React from 'react';
import styles from './EventButtons.module.scss';
import cn from 'classnames';

const DeleteButton = ({ onClick }: IProps) => (
    <div className={cn(styles.button, styles.button_delete)} onClick={onClick} />
);

export default DeleteButton;

interface IProps {
    onClick: () => void;
}
